import React from 'react';
import { useAppSelector } from './store/hooks';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Routing from './Routing/Routing';
import i18n from './i18n';
import { createTheme4d } from './theme4d';

const App: React.FC = () => {
    const language = useAppSelector(state => state.main.language);
    const a11yContrast = useAppSelector(state => state.main.a11yContrast);
    const a11yLinkHighlight = useAppSelector(state => state.main.a11yLinkHighlight);
    const dir = i18n.dir(language);
    const theme = React.useMemo(() => createTheme4d(dir, a11yContrast), [dir, a11yContrast]);

    React.useEffect(() => {
        document.documentElement.dir = dir;
        i18n.changeLanguage(language);
      }, [language, dir]);

    React.useEffect(() => {
        document.body.classList.toggle('a11y-link-highlight', a11yLinkHighlight);
    }, [a11yLinkHighlight]);

    return (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div style={{ minHeight: '100vh', filter: a11yContrast === 'blackAndWhite' ? 'grayscale(1)' : 'none' }}>
            <Routing/>
          </div>
        </ThemeProvider>
    );
};

export default App;
